var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4508 1.31672L1.30667 1.50063C1.06883 1.80411 0.868084 2.15666 0.718003 2.53912C0.578232 2.90791 0.493199 3.25427 0.454399 3.59771L0.45406 3.60071C0.10889 6.46216 1.39034 9.13196 5.14792 12.8896C5.14792 12.8896 5.14793 12.8896 5.14793 12.8896M1.4508 1.31672L5.14793 12.8896M1.4508 1.31672L2.03848 0.725661L1.4508 1.31672ZM5.14793 12.8896C10.2404 17.9818 14.3055 17.6029 14.4439 17.5887M5.14793 12.8896L14.4439 17.5887M14.4439 17.5887C14.8048 17.5453 15.1505 17.4592 15.5043 17.3218C15.8834 17.1737 16.2362 16.9731 16.5401 16.7353L16.6855 16.6215L17.3161 16.0041C17.3166 16.0035 17.3171 16.003 17.3177 16.0025C17.7438 15.5738 17.7409 14.9089 17.3533 14.5198C17.3532 14.5197 17.3531 14.5196 17.353 14.5195L14.568 11.7341C14.5678 11.734 14.5677 11.7338 14.5675 11.7337C14.1781 11.3463 13.5125 11.3443 13.0849 11.7721L13.0848 11.7721L11.6812 13.1755L11.4686 13.388L11.2053 13.2429C11.116 13.1937 11.0236 13.1424 10.9267 13.0879C10.9263 13.0877 10.926 13.0875 10.9256 13.0873L11.1214 12.7385C10.235 12.2474 9.02179 11.5742 7.74517 10.2967L14.4439 17.5887Z",
    stroke: "#956D84",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ebc94afcd532fa24d34dcf726617d810.svg";
export { ForwardRef as ReactComponent };